module.exports = __webpack_public_path__ + "img/57_11.22c06016.png";